<div class="sectionContainer paddedContent" style="margin: 10px">
  <app-user-form
    #userForm
    [user]="user"
    [showCloseButton]="true"
    [enableEditing]="true"
    [enableSaving]="true"
    [merchantId]="merchantId"
    [isNew]="isNew"
    [enableSelectExistingUser]="true"
    [enableRoleSelection]="true"
    [initialMode]="FormMode.Edit"
    (close)="btnCancel_click()"
  ></app-user-form>
  
  <div style="display: flex; align-items: start; gap: 20px; margin: 20px auto; justify-content: center;">
    <input
      type="button"
      value="Cancel"
      class="cancel"
      (click)="btnCancel_click()"
    />
    <input
      [disabled]="!userForm.isValid"
      type="button"
      [value]="user != undefined && user.id != '' ? 'Save changes' : 'Submit'"
      class="primary"
      (click)="btnSave_click()"
    />
  </div>
</div>
